import { ViewWebOrderGstSetupDto } from "./view-web-order-gst-setup-dto";
import { ViewWebOrderDeliverySetUpDto } from "./viewweborderdeliverysetUpdto";

export class WebOrderDeliverySetupDto {
    viewWebOrderDeliverySetUpDto: ViewWebOrderDeliverySetUpDto[] = [];
    viewWebOrderGstSetupDto: ViewWebOrderGstSetupDto;
    deliveryChargeByDistance: number;
}
